import { Button, Grid, Typography, useTheme } from "@mui/material";
import { MONTH } from "../../data/data";

const CustomMonthCalender = ({
    selectedValue="",
    onSelectMonth
}) => {
    const theme = useTheme();

    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='center'
                container
                spacing={3}
                p={3}
            >
                {
                    MONTH.map((item, index) => {
                        return <Grid size={4} key={index}>
                            <Button
                                sx={{
                                    backgroundColor: item.value === selectedValue ? theme.palette.primary.main : 'transparent',
                                    borderRadius: '8px',
                                    py: 1,
                                    px: 0.5,
                                    width: '100%',
                                    textTransform: 'none'
                                }}
                                onClick={() => onSelectMonth(item.value)}
                            >
                                <Typography
                                    fontWeight={400}
                                    fontSize={12}
                                    letterSpacing={0.5}
                                    textAlign="center"
                                    color={item.value === selectedValue ? "white" : "#5E5959"}
                                >
                                    {item.label}
                                </Typography>
                            </Button>
                        </Grid>
                    })
                }
            </Grid>
        </>
    );
}

export default CustomMonthCalender;